export default __webpack_public_path__ + "static/media/background-2.33f95f34.svg";